import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { DELETE_WATCH_LIST_ENTRY } from '../types';
import { deleteWatchListEntryFulfilled, deleteWatchListEntryPending, deleteWatchListEntryRejected } from '../actions';
import { sendApiRequest } from '../../../actions/apiRequestActions';
import { notifyError, notifySuccess } from '../../../actions';
import { WATCH_LIST_ENTRY_MESSAGES } from '../constants/watchListEntryMessages';
import generateError from '../../../utilities/generateError';

const createPayload = id => ({
  method: 'delete',
  url: 'watchlistentry/delete',
  onSuccess: [
    deleteWatchListEntryFulfilled,
    () => notifySuccess(WATCH_LIST_ENTRY_MESSAGES.DELETED),
  ],
  onError: [
    deleteWatchListEntryRejected,
    error => notifyError(generateError(error)),
  ],
  data: { id },
});

const meta = {
  api: 'ajaxApi',
};

const deleteWatchListEntryEpic$ = action$ => action$.pipe(
  ofType(DELETE_WATCH_LIST_ENTRY.DEFAULT),
  mergeMap(({ payload }) => merge(
    of(deleteWatchListEntryPending()),
    of(sendApiRequest(createPayload(payload), meta)),
  )),
);

export default deleteWatchListEntryEpic$;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/epics/deleteWatchListEntryEpic.js